'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dDescription$0024$0024anon$002441 from "./presto.types$-Grouping-Description$$anon$41.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dDescription$0024$0024anon$002442 from "./presto.types$-Grouping-Description$$anon$42.js";
var $p;
/** @constructor */
function $c_Lpresto_types$GroupingDescription$() {
  this.c7d = null;
  this.c7e = false;
  this.c7b = null;
  this.c7c = false;
  this.c7h = null;
  this.c7i = false;
  this.c7f = null;
  this.c7g = false;
  this.c7j = null;
  this.c7k = false;
}
export { $c_Lpresto_types$GroupingDescription$ as $c_Lpresto_types$GroupingDescription$ };
$p = $c_Lpresto_types$GroupingDescription$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$GroupingDescription$;
/** @constructor */
function $h_Lpresto_types$GroupingDescription$() {
}
export { $h_Lpresto_types$GroupingDescription$ as $h_Lpresto_types$GroupingDescription$ };
$h_Lpresto_types$GroupingDescription$.prototype = $p;
$p.cId = (function() {
  if ((!this.c7e)) {
    this.c7d = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c7e = true;
  }
  return this.c7d;
});
$p.p3 = (function() {
  if ((!this.c7c)) {
    this.c7b = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c7c = true;
  }
  return this.c7b;
});
$p.cIR = (function() {
  if ((!this.c7i)) {
    this.c7h = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c7i = true;
  }
  return this.c7h;
});
$p.cID = (function() {
  if ((!this.c7g)) {
    this.c7f = new $j_presto$002etypes$0024$002dGrouping$002dDescription$0024$0024anon$002441.$c_Lpresto_types$GroupingDescription$$anon$41(this);
    this.c7g = true;
  }
  return this.c7f;
});
$p.cJ9 = (function() {
  if ((!this.c7k)) {
    this.c7j = new $j_presto$002etypes$0024$002dGrouping$002dDescription$0024$0024anon$002442.$c_Lpresto_types$GroupingDescription$$anon$42(this);
    this.c7k = true;
  }
  return this.c7j;
});
var $d_Lpresto_types$GroupingDescription$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$GroupingDescription$, "presto.types$GroupingDescription$", ({
  a0f: 1,
  D: 1
}));
export { $d_Lpresto_types$GroupingDescription$ as $d_Lpresto_types$GroupingDescription$ };
var $n_Lpresto_types$GroupingDescription$;
function $m_Lpresto_types$GroupingDescription$() {
  if ((!$n_Lpresto_types$GroupingDescription$)) {
    $n_Lpresto_types$GroupingDescription$ = new $c_Lpresto_types$GroupingDescription$();
  }
  return $n_Lpresto_types$GroupingDescription$;
}
export { $m_Lpresto_types$GroupingDescription$ as $m_Lpresto_types$GroupingDescription$ };
//# sourceMappingURL=presto.types$-Grouping-Description$.js.map
